import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=2142c876&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports